import React from "react";

import { TypeAnimation } from "react-type-animation";
import { motion } from "framer-motion";
import { fadeIn } from "../variants";
import Image2 from "../assets/avatar.png";
import "./Banner.css";

import { useState, useEffect } from "react";

import { Link } from "react-scroll";
import { set } from "animejs";

import { ArrowDown, Github, Linkedin, Twitter, Youtube } from "lucide-react";

import { SiBilibili } from "react-icons/si";

const Banner = () => {
  const gradients = [
    "from-pink-500 via-red-500 to-yellow-500",
    "from-indigo-500 via-purple-500 to-pink-500",
    "from-green-400 via-blue-500 to-purple-600",
    "from-yellow-400 via-red-500 to-pink-500",
    "from-cyan-400 via-sky-500 to-blue-500",
    "from-blue-500 via-purple-500 to-pink-500",
    "from-green-400 via-teal-500 to-blue-500",
    "from-red-400 via-yellow-500 to-green-500",
    "from-purple-400 via-pink-500 to-red-500",
    "from-orange-400 via-yellow-500 to-green-500",
    "from-pink-400 via-red-500 to-yellow-500",
    "from-teal-400 via-blue-500 to-purple-600",
    "from-blue-400 via-indigo-500 to-purple-600",
    "from-yellow-400 via-orange-500 to-red-500",
    "from-pink-400 via-purple-500 to-blue-500",
    "from-green-400 via-yellow-500 to-red-500",
    "from-purple-400 via-pink-500 to-red-500",
  ];

  const [gradient, setGradient] = useState(gradients[0]);
  const [index, setIndex] = useState(0);

  const nextGradient = () => {
    const next = Math.floor((Math.random() / 2) * gradients.length);
    setGradient(gradients[next]);
  };

  const [showImage, setShowImage] = useState(false); // 初始图片
  const [isTransitioning, setIsTransitioning] = useState(false); // 过渡中
  const [showFinalSvg, setShowFinalSvg] = useState(false); // 最终 SVG

  const handleDownloadClick = () => {
    setIsTransitioning(true);
    setShowFinalSvg(false);

    // 下载简历
    const link = document.createElement("a");
    link.href = "/Juanyan Zhu_Frontend_CV_v3.pdf";
    link.download = "Edison_Zhu_Resume.pdf";
    link.click();

    // 模拟加载动画后展示最终 SVG
    setTimeout(() => {
      setIsTransitioning(false);
      setShowFinalSvg(true);

      // ⏱️ 再等 10 秒后自动还原为默认图片
      setTimeout(() => {
        setShowFinalSvg(false);
      }, 10000); // 10000 毫秒 = 10 秒
    }, 1000); // 过渡动画时间
  };

  useEffect(() => {
    return () => {
      clearTimeout(); // 清理上次的 timer（如果你用 useRef 保存定时器 ID）
    };
  }, []);

  return (
    <section
      className="min-h-[100vh] lg:min-h-[100vh] flex items-center"
      id="home"
    >
      <div className="container mx-auto">
        <div className="flex flex-col gap-y-6 lg:flex-row justify-between lg:items-center">
          {/* text section */}
          <div className="flex-1 text-center lg:text-left">
            <motion.h1
              variants={fadeIn("up", 0.3)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="text-[40px] lg:text-[60px] font-bold leading-[0.8] mb-2"
            >
              <span className="dark:text-white text-black">Hi, I am</span>{" "}
              <span>
                <span>
                  <span className="text-amber-600 dark:text-green-500">
                    <button
                      onClick={handleDownloadClick}
                      className="group cursor-pointer lg:text-[80px] bg-transparent border-none"
                      onMouseEnter={() => setShowImage(true)}
                      onMouseLeave={() => setShowImage(false)}
                    >
                      <span>Edison Zhu</span>
                    </button>
                  </span>
                </span>
              </span>
            </motion.h1>
            <motion.div
              variants={fadeIn("up", 0.5)}
              initial="hidden"
              whileInView={"show"}
              viewport={{ once: false, amount: 0.7 }}
              className="text-[50px] lg:text-[100px]font-bold leading-[1] mb-2"
            >
              <span className="dark:text-white text-black font-semibold ">
                A{" "}
                <span
                  className={`transition-all duration-1000 bg-gradient-to-r ${gradient} bg-clip-text text-transparent`}
                >
                  <TypeAnimation
                    sequence={[
                      "Web Developer",
                      2000,
                      "", // 清空文字
                      () => nextGradient(), // 换颜色
                      "Software Engineer",
                      2000,
                      "", // 清空文字
                      () => nextGradient(), // 换颜色
                      "Designer",
                      2000,
                      "", // 清空文字
                      () => nextGradient(), // 换颜色
                      "Creator",
                      2000,
                      "", // 清空文字
                      () => nextGradient(), // 换颜色
                    ]}
                    speed={10}
                    className=""
                    wrapper="span"
                    cursor={false}
                    repeat={Infinity}
                  />
                </span>
                <span class="typing">l</span>
              </span>
            </motion.div>
            <motion.div
              variants={fadeIn("up", 0.7)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.7 }}
              className="text-[50px] lg:text-[100px] font-bold mb-6 text-center hidden lg:text-left lg:block"
            >
              <div className="flex justify-center lg:justify-start items-center space-x-6">
                <a
                  href="https://github.com/EdisonJun"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="opacity-50 hover:opacity-100 "
                  aria-label="GitHub"
                >
                  <Github size={40} />
                </a>
                <a
                  href="https://www.linkedin.com/in/juanyan-edison-zhu/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="opacity-50 hover:opacity-100 "
                  aria-label="LinkedIn"
                >
                  <Linkedin size={40} />
                </a>
                <a
                  href="https://space.bilibili.com/7067751?spm_id_from=333.337.0.0"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="opacity-50 hover:opacity-100 "
                  aria-label="Bilibili"
                >
                  <SiBilibili size={40} />
                </a>
              </div>
            </motion.div>
          </div>
          {/* image section */}
          <motion.div
            variants={fadeIn("down", 0.5)}
            initial="hidden"
            whileInView={"show"}
            className="h-[350px] hidden lg:flex" // 固定容器高度，并居中内容
          >
            {isTransitioning ? (
              // 过渡中的旋转动画 SVG
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-full text-blue-500 animate-spin"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
                />
              </svg>
            ) : showFinalSvg ? (
              // 最终 SVG
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-full text-green-500"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M10.125 2.25h-4.5c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125v-9M10.125 2.25h.375a9 9 0 0 1 9 9v.375M10.125 2.25A3.375 3.375 0 0 1 13.5 5.625v1.5c0 .621.504 1.125 1.125 1.125h1.5a3.375 3.375 0 0 1 3.375 3.375M9 15l2.25 2.25L15 12"
                />
              </svg>
            ) : showImage ? (
              // hover 时显示的 SVG
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="text-black dark:text-white w-full"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m.75 12 3 3m0 0 3-3m-3 3v-6m-1.5-9H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                />
              </svg>
            ) : (
              // 默认图片
              <img
                src={Image2}
                alt="Edison"
                className="w-full rounded-full shadow-2xl "
                style={{
                  filter: `
                    drop-shadow(0 0 60px rgba(219,69,205,1))
                    drop-shadow(0 0 120px rgba(219,69,205,0.8))
                    drop-shadow(0 0 180px rgba(219,69,205,0.6))
                    `,
                }}
              />
            )}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
